if (!customElements.get('surf-guides-slider')) {
  class SurfGuidesSlider extends HTMLElement {
    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.featured-blog__items',
        prevEl: '.swiper-btn-prev',
        nextEl: '.swiper-btn-next',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      const sliderOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        breakpoints: {
          1024: {
            slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
            spaceBetween: columnGap.tabletLarge,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            spaceBetween: columnGap.desktop,
          },
        },
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add('swiper');
        this.sliderWrapper.classList.remove('f-grid');
        this.sliderWrapper.classList.add('swiper-wrapper');
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const index = Number(e.target.dataset.index);
          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }
  }
  customElements.define('surf-guides-slider', SurfGuidesSlider);
}
